import { Component, input } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent } from '@camelot/ui';

import { VisitStatus } from '../../services/dto/visit';

export const visitStatusLabel = (visitStatus: VisitStatus) =>
  `planning.visit-status.${VisitStatus[visitStatus]?.toLowerCase() ?? 'unknown'}`;

@Component({
  selector: 'cam-visit-status',
  templateUrl: './visit-status.component.html',
  styleUrls: ['./visit-status.component.scss'],
  imports: [BadgeComponent, TranslatePipe],
})
export class VisitStatusComponent {
  status = input.required<number | VisitStatus>();

  public label() {
    return visitStatusLabel(this.status());
  }
  public type() {
    switch (this.status()) {
      case VisitStatus.Canceled:
        return 'danger';
      case VisitStatus.Draft:
        return 'warning';
      case VisitStatus.Planned:
        return 'success';
      case VisitStatus.Done:
        return 'secondary';
      default:
        return 'primary';
    }
  }
}
